/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { toast } from 'react-hot-toast';
//import { CustomToastVW } from "../widgets/CustomToastVW";

export const getErrorMessage = (err: any) => {
  let _display_message =
    err?.graphQLErrors &&
    Array.isArray(err?.graphQLErrors) &&
    err?.graphQLErrors.find((item: any) => item.extensions);
  console.log('display message', _display_message);
  if (_display_message?.extensions?.display_message) {
    // return
    // toast.custom((t) => (
    //     <CustomToastVW message={_display_message?.extensions?.display_message} errorCode={_display_message?.extensions?.error_code} />
    // ));
    toast.error(_display_message?.extensions?.display_message);
  } else {
    toast.error(
      'Something went wrong, please try again'
    );
    //     toast.custom((t) => (
    //         <CustomToastVW message={_display_message?.message ?? "Something went wrong, please try again"} />
    //     ));
  }
};
